import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

export const PackageBox = styled(FlexDiv)`
  margin: 0 -8px;
  flex-wrap: wrap;
  @media only screen and (max-width: 992px) {
    margin: 0;
    padding: 0 8px;
  }
`;
export const PackageTitle = styled(Typography)``;
export const TopBox = styled(FlexDiv)`
  position: relative;
  padding: 8px 16px;
  ${PackageTitle} {
    max-width: calc(100% - 38px);
    width: 100%;
  }
  @media only screen and (max-width: 1079px) {
    padding: 12px 16px;
  }
`;
export const PackageItem = styled(FlexDiv)`
  width: 100%;
  position: relative;
  cursor: pointer;
  max-width: calc(50% - 16px);
  user-select: none;
  margin: 0 8px 16px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 24px;
  flex-direction: column;
  & * {
    transition: all 0.3s ease-in-out;
  }
  border: 2px solid
    ${({ theme, isActive }) =>
      isActive
        ? theme.colorsV2.shyft.purple_text
        : theme.colorsV2.blueGray.shade_100};
  border-radius: 16px;
  ${PackageTitle} {
    color: ${({ theme, isActive }) =>
      isActive
        ? theme.colorsV2.primary.shade_900
        : theme.colorsV2.gray.shade_700};
  }
  ${TopBox} {
    ${({ theme, isActive }) =>
      !isActive &&
      `
      &:before{
        content:"";
        height: 26px;
        width: 26px;
        border:2px solid ${theme.colorsV2.gray.shade_300};
        border-radius:50%;
        position:absolute;
        top: 50%;
        right: 18px;
        transform: translateY(-50%);
      }
    `}
  }
  @media only screen and (max-width: 1079px) {
    border-width: 4px;
    margin: 0 8px 8px;
    padding: 4px;
    &:last-child {
      margin: 0 8px 16px;
    }
  }
  @media only screen and (max-width: 992px) {
    max-width: 100%;
    margin: 0 0px 8px;
    &:last-child {
      margin: 0 0px 16px;
    }
  }
`;
export const SelectedIcon = styled(StyledSvgSprite)`
  position: absolute;
  top: 50%;
  right: 16px;
  height: 32px;
  width: 32px;
  fill: ${({ theme }) => theme.colorsV2.success.shade_600};
  transform: translateY(-50%);
`;
export const BottomBox = styled(FlexDiv)`
  padding: 0 16px;
  flex-direction: column;
  @media only screen and (max-width: 1079px) {
    padding: 8px 16px;
  }
`;
export const Subtitle = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
`;
export const Description = styled(Typography)`
  margin-top: 16px;
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
`;
